import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export enum NOTIFICATION_TYPE {
  ITEM_BANNED = 'ITEM_BANNED',
  ITEM_UNBANNED = 'ITEM_UNBANNED',
  ITEM_COMMENT = 'ITEM_COMMENT',
  ITEM_SHARE_INVITE_SENT = 'ITEM_SHARE_INVITE_SENT',
  ITEM_SHARE_INVITE_RECEIVED = 'ITEM_SHARE_INVITE_RECEIVED',
  ITEM_SHARE_INVITE_ACCEPTED = 'ITEM_SHARE_INVITE_ACCEPTED',
  GROUP_INVITE_SENT = 'GROUP_INVITE_SENT',
  GROUP_INVITE_RECEIVED = 'GROUP_INVITE_RECEIVED',
  GROUP_INVITE_ACCEPTED = 'GROUP_INVITE_ACCEPTED',
  ITEM_PROCESSING_SUCCESS = 'ITEM_PROCESSING_SUCCESS',
  ITEM_PROCESSING_FAILED = 'ITEM_PROCESSING_FAILED',
}

export const NotificationSchema = Type.Object({
  id: Type.String({ format: 'uuid' }),
  type: Type.String(),
  metadata: Type.Union([Type.Record(Type.String(), Type.Any()), Type.Null()]),
  is_read: Type.Boolean(),
  created_at: Type.String(),
});
export type NotificationResponse = Static<typeof NotificationSchema>;

export const GetNotificationsQuerySchema = Type.Object({
  page: Type.Integer({ default: 1 }),
  pageSize: Type.Integer({ default: 20 }),
});

export const GetNotificationsResponseSchema = Type.Object({
  data: Type.Object({
    notifications: Type.Array(NotificationSchema),
    totalItems: Type.Number(),
    pageSize: Type.Number(),
    totalPages: Type.Number(),
  }),
});

export const GetUnreadNotificationCountResponseSchema = Type.Object({
  data: Type.Object({
    count: Type.Number(),
  }),
});
